var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg5 = function Svg5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 21H7.59417C5.72945 20.85 2 19.38 2 14.7C2 11.55 5.0625 9.3 7.25 9.3C7.25 7.95 9 3 14.25 3C17.75 3 19.5 5.25 20.5302 6.6C21.4335 6.15 23.875 6.15 25.1875 6.6C26.5 7.05 30 9.3 30 13.8C30 18.3 26.0625 21 22.7742 21Z",
    fill: "url(#paint0_linear_906_536241)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7764 24.1024C9.9708 24.1567 11.2057 27.4614 10.9168 28.5397C10.7751 29.0545 10.4123 29.4863 9.90772 29.7408C9.40309 29.9953 8.79759 30.0518 8.22345 29.8979C7.6493 29.7441 7.15317 29.3924 6.84339 28.9197C6.53361 28.447 6.43536 27.8917 6.5701 27.375C6.85901 26.2967 9.58189 24.0482 9.7764 24.1024Z",
    fill: "#42A0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7764 24.1024C16.9708 24.1567 18.2057 27.4614 17.9168 28.5397C17.7751 29.0545 17.4123 29.4863 16.9077 29.7408C16.4031 29.9953 15.7976 30.0518 15.2234 29.8979C14.6493 29.7441 14.1532 29.3924 13.8434 28.9197C13.5336 28.447 13.4354 27.8917 13.5701 27.375C13.859 26.2967 16.5819 24.0482 16.7764 24.1024Z",
    fill: "#42A0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7764 24.1024C23.9708 24.1567 25.2057 27.4614 24.9168 28.5397C24.7751 29.0545 24.4123 29.4863 23.9077 29.7408C23.4031 29.9953 22.7976 30.0518 22.2234 29.8979C21.6493 29.7441 21.1532 29.3924 20.8434 28.9197C20.5336 28.447 20.4354 27.8917 20.5701 27.375C20.859 26.2967 23.5819 24.0482 23.7764 24.1024Z",
    fill: "#42A0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2764 17.1024C13.4708 17.1567 14.7057 20.4614 14.4168 21.5397C14.2751 22.0545 13.9123 22.4863 13.4077 22.7408C12.9031 22.9953 12.2976 23.0518 11.7234 22.8979C11.1493 22.7441 10.6532 22.3924 10.3434 21.9197C10.0336 21.447 9.93536 20.8917 10.0701 20.375C10.359 19.2967 13.0819 17.0482 13.2764 17.1024Z",
    fill: "#42A0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2764 17.1024C21.4708 17.1567 22.7057 20.4614 22.4168 21.5397C22.2751 22.0545 21.9123 22.4863 21.4077 22.7408C20.9031 22.9953 20.2976 23.0518 19.7234 22.8979C19.1493 22.7441 18.6532 22.3924 18.3434 21.9197C18.0336 21.447 17.9354 20.8917 18.0701 20.375C18.359 19.2967 21.0819 17.0482 21.2764 17.1024Z",
    fill: "#42A0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_536241",
    x1: 6.91448,
    y1: 4.5068,
    x2: 24.7045,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5.dbc8c0c0.svg";
export { ForwardRef as ReactComponent };